import { __awaiter, __generator } from "tslib";
import { checkboxKey } from './checkbox';
export var createCheckboxDriver = function (wrapper, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$("." + checkboxKey).get(idx);
    var value = function () { return base.hasClass('checked'); };
    var toggle = function () { return base.$('input').click(); };
    return {
        toggle: toggle,
        label: base.$('.checkbox-body').text,
        value: value,
        set: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            var curr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, value()];
                    case 1:
                        curr = _a.sent();
                        if (!(curr !== val)) return [3 /*break*/, 3];
                        return [4 /*yield*/, toggle()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        isDisabled: function () { return base.hasClass('disabled'); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map